import React from 'react';
import { etkinlikler } from '../data/EtkinliklerLise';
import CardGrid from '../../components/CardGrid';

const EtkinliklerLise= () => {
  return (
    <div className="px-4 md:px-16 py-20" style={{ backgroundImage: "url('/background.png')" }} >
      <h1 className="text-3xl font-bold text-[#a03838] mb-8 text-center">
        Lise Etkinliklerimiz
      </h1>
      <CardGrid data={etkinlikler} isPdfMode={false} basePath="/etkinlikler" kategori="lise"/>
    </div>
  );
};

export default EtkinliklerLise;